import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import leftTree from '@blade-sxp/device-management/components/left-tree.vue';
import rightTable from '@blade-sxp/device-management/components/right-table.vue';
import { summaryDevice } from '@blade-sxp/device-management/api/device-management/index';
let default_1 = class extends Vue {
    upload = false;
    data = {};
    groupId = '';
    currentKey = '';
    batchBtnIsShow = false;
    getAllMsg() {
        summaryDevice().then((res) => {
            this.data = res;
        });
    }
    nodeClick(nodeItem) {
        if (nodeItem.type === 'favorites' || nodeItem.type === 'favoritesBox' || nodeItem.remark === 'Ungrouped Device') {
            this.batchBtnIsShow = false;
        }
        else {
            this.batchBtnIsShow = true;
        }
        if (nodeItem.type === 'favorites' || nodeItem.type === 'favoritesBox') {
            this.groupId = 'favorites';
        }
        else {
            this.groupId = String(nodeItem.id);
        }
    }
    changeForm() {
        // this.groupId = '';
        // (this.$refs.leftTree as HTMLFormElement).$refs.tree.setCurrentKey(null);
    }
    changeTopText() {
        this.getAllMsg();
    }
    boxMsgSuccess(currentKey, isAdd) {
        this.groupId = currentKey;
        this.$refs.leftTree.getOtherTree(isAdd);
    }
    mounted() { }
};
default_1 = __decorate([
    Component({
        name: 'deviceManagement',
        components: {
            leftTree,
            rightTable,
        },
        i18n: {
            messages: {
                zh: {
                    deviceManagement: '设备管理',
                    total: '( 总共:{msg};',
                    online: '在线:{msg};',
                    offline: '离线:{msg};',
                    unknown: '未知:{msg} )',
                },
                en: {
                    deviceManagement: 'Device Management',
                    total: '( Total:{msg};',
                    online: 'Online:{msg};',
                    offline: 'Offline:{msg};',
                    unknown: 'Unknown:{msg} )',
                },
            },
        },
    })
], default_1);
export default default_1;
